export function getAtPath(obj: unknown, path: string): unknown {
    if (obj == null || typeof obj !== 'object') return undefined;
    const parts = path.split('.');
    let current: unknown = obj;
    for (const part of parts) {
        if (current == null || typeof current !== 'object') return undefined;
        current = (current as Record<string, unknown>)[part];
    }
    return current;
}

export function hasAtPath(obj: unknown, path: string): boolean {
    if (obj == null || typeof obj !== 'object') return false;
    const parts = path.split('.');
    let current: unknown = obj;
    for (const part of parts) {
        if (current == null || typeof current !== 'object') return false;
        if (!Object.prototype.hasOwnProperty.call(current, part)) return false;
        current = (current as Record<string, unknown>)[part];
    }
    return true;
}

export function setAtPath(
    obj: Record<string, unknown>,
    path: string,
    value: unknown
): Record<string, unknown> {
    const parts = path.split('.');
    let current: Record<string, unknown> = obj;
    for (let i = 0; i < parts.length - 1; i += 1) {
        const part = parts[i];
        const next = current[part];
        if (next == null || typeof next !== 'object' || Array.isArray(next)) {
            current[part] = {};
        }
        current = current[part] as Record<string, unknown>;
    }
    current[parts[parts.length - 1]] = value;
    return obj;
}

export function emptyIdentity(): {
    name: string;
    tags: string[];
    states: string[];
    allStates: boolean;
    licenceTypes: { state: string; code: string }[];
    activeStatus: 'Active' | 'Inactive';
} {
    return {
        name: '',
        tags: [],
        states: [],
        allStates: false,
        licenceTypes: [],
        activeStatus: 'Active',
    };
}
